<template>
  <b-form-group
    :label="label">
    <b-form-textarea
      :ref="`ref${name}`"
      type="text"
      :name="name"
      :placeholder="placeholder"
      v-model="valor"
      :state="verificaEstadoInput()"
      :min="valMin"
      :rows="rows"
      :max-rows="maxrows"
      :disabled="disabled"
      @input="onStateInput($event, 'onInput')"
      @change="onStateInput($event, 'onChange')"
      @update="onStateInput($event, 'onUpdate')"
      @blur="$emit('blur')"
      autocomplete="off"
    />
    <b-form-invalid-feedback>
      {{ retornaMensagemDeErro() }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group'
import bFormTextarea from 'bootstrap-vue/es/components/form-textarea/form-textarea'
import bFormInvalidFeedback from 'bootstrap-vue/es/components/form/form-invalid-feedback'
import InputBaseMixins from './mixins/InputBaseMixins'

export default {
  name: 'InputDescricao',
  mixins: [InputBaseMixins],
  components: {
    bFormGroup,
    bFormInvalidFeedback,
    bFormTextarea,
  },
  props: {
    rows: {
      type: Number,
      default: 2,
    },
    maxrows: {
      type: Number,
      default: 4,
    },
  },
}
</script>
